module.exports = __webpack_public_path__ + "static/media/font.0d4f6f9e.woff2";